import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ORSMActivationConfirmation from './ORSMActivationConfirmation';
import { Size } from '../../../../Enums/Size.enum';

const ORSMActivationConfirmationModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal
			{...props}
			title='component.ORSMActivationConfirmation.modalTitle'
			headerEnabled={false}
			size={Size.MD}>
			<ORSMActivationConfirmation onClose={props.onClose} />
		</BaseModal>
	);
};

export default ORSMActivationConfirmationModal;
